import * as React from "react"
import "../styles.css"
import * as pageStyles from "../page_css/page.css"
import * as headerHero2025Styles from "./header-hero-2025.css"
import * as styles from "./page-hero.css"
import { theme } from "../theme.css"
import { GatsbyImage, getImage, IGatsbyImageData } from "gatsby-plugin-image"
import { colorArrayToString } from "../utils"
import { TColor } from "../types"
import Flash from "../components/flash"
import StandardCard from "../components/blocks/StandardCard"
import TicketLink  from "../components/ticket-link"
import Bumbershoot2024BlueAnim from "../graphics/Bumbershoot-2024-blue-anim.svg"
import LineupNav from "../components/lineup-nav"
import {
  Text,
  Button,
} from "../components/ui"

import {
  NavLink,
  VisuallyHidden,
} from "./ui"
import * as stylesHeader from "./header.css"
import Badge from "./badge"
import { StaticImage } from "gatsby-plugin-image"


export default function HeaderHero2025() {
  return (
    <>
    <div className={headerHero2025Styles.custom2025HeaderHeroColumn}>
        <div className={headerHero2025Styles.heroTextColumn}>
          <h1 className={headerHero2025Styles.custom2025HeaderHeroText}
          style={{  marginBottom: 40, marginLeft: "20px", marginRight: "20px", textAlign: "center" }}
          >
            All Ticket Types On Sale
          </h1>

          {/*
          <h1
            className={headerHero2025Styles.custom2025HeaderHeroSubText}
            style={{ marginTop: 10, marginBottom: 40, textAlign: "center" }}
          >
            2-day tickets starting at $225&nbsp;+ fees
          </h1>
          */}
          <Button
            variant="rubyButton"
            to="https://wl.eventim.us/event/Bumbershoot-2025-Arts-and-Music-Festival/618086?afflky=ThirdStone&sp=8TSXH4"
            target="_blank"
          >
            Buy&nbsp;Tickets
          </Button>
        </div>
   
       <div className={headerHero2025Styles.custom2025HeaderHero}>
        {/*  ── Left column  */}
          <div className={headerHero2025Styles.heroImageColumn}>
            <a href="/music-lineup">
              <StaticImage
                src="../graphics/admats/BBS_AdMat_Music_Digital_1200x1800_6_27.jpg"
                alt="2025 Bumbershoot Music Admat"
                placeholder="blurred"
                className={headerHero2025Styles.heroImage}
              />
            </a>
        </div>

        {/*  ── Right column  */}
        <div className={headerHero2025Styles.heroImageColumn}>
          <a href="/artist-lineup">
            <StaticImage
              src="../graphics/admats/BBS_AdMat_Music_Arts_Digital_1200x1800_6_27.jpg"
              alt="2025 Bumbershoot Arts Admat"
              placeholder="blurred"
              className={headerHero2025Styles.heroImage}
            />
          </a>
        </div>
        </div>
    </div>
      </>
  );
}
